/** A departed or camera-off colleague must not turn a connected call back into a ring. */
export function isRingingOut(minimised: boolean, hasRemoteAttendeeJoined: boolean): boolean {
  return minimised && !hasRemoteAttendeeJoined;
}
